export default __webpack_public_path__ + "static/14-7088f52f0e74fa005365f15b4a0fc054.svg";